<template>
  <Layout>
    <PageHeader :title="title" />
    <v-app>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="row mb-3">
                  <div class="col-lg-12">
                    <v-expansion-panels flat popout hover>
                      <v-expansion-panel>
                        <v-expansion-panel-header class="bg-light">
                          <span
                            ><v-icon left>mdi-magnify</v-icon>Detaylı
                            Arama</span
                          >
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div class="container-xxl-fluid">
                            <div class="row">
                              <div class="col-lg-3">
                                <search-select
                                  :search-type="'current'"
                                  @itemChange="(e) => (selectedCurrent = e)"
                                  :label="'Cari'"
                                >
                                </search-select>
                              </div>
                              <div class="col-lg-3">
                                <v-select
                                  v-model="salesPersonCode"
                                  label="Plasiyer"
                                  filled
                                  solo
                                  dense
                                  clearable
                                  :items="salesPersonList"
                                  :item-text="(item) => item.name"
                                  :item-value="(item) => item.code"
                                >
                                </v-select>
                              </div>
                              <div class="col-lg-3">
                                <v-select
                                  v-model="branchcode"
                                  label="Şube Kodu"
                                  filled
                                  solo
                                  dense
                                  :items="branchList"
                                  item-value="code"
                                  item-text="name"
                                >
                                </v-select>
                              </div>

                              <div class="col-lg-3">
                                <v-select
                                  v-model="isErp"
                                  label="Durum"
                                  filled
                                  solo
                                  dense
                                  :items="[
                                    { value: 2, text: 'Onaylanmadı' },
                                    { value: 1, text: 'Onaylandı' },
                                  ]"
                                  item-value="value"
                                  item-text="text"
                                >
                                </v-select>
                              </div>

                              <div class="col-lg-3">
                                <v-select
                                  v-model="type"
                                  label="Tip"
                                  filled
                                  solo
                                  dense
                                  :items="[
                                    { value: 2, text: 'Kredi Kartı' },
                                    { value: 1, text: 'Nakit' },
                                  ]"
                                  item-value="value"
                                  item-text="text"
                                >
                                </v-select>
                              </div>

                              <div class="col-lg-3">
                                <v-menu
                                  transition="scale-transition"
                                  offset-y
                                  :close-on-content-click="false"
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      :value="formattedDate(startDate)"
                                      label="Tarih Aralık Başlangıç"
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      filled
                                      solo
                                      dense
                                      clearable
                                      @click:clear="startDate = null"
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="startDate"
                                    locale="tr"
                                  ></v-date-picker>
                                </v-menu>
                              </div>
                              <div class="col-lg-3">
                                <v-menu
                                  transition="scale-transition"
                                  offset-y
                                  :close-on-content-click="false"
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      :value="formattedDate(endDate)"
                                      label="Tarih Aralık Bitiş"
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      filled
                                      solo
                                      dense
                                      clearable
                                      @click:clear="endDate = null"
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="endDate"
                                    locale="tr"
                                  ></v-date-picker>
                                </v-menu>
                              </div>
                              <div class="col-lg-12 text-end">
                                <v-btn
                                  color="primary darken-1"
                                  small
                                  @click="_fetchAllCollections"
                                >
                                  <v-icon left>mdi-magnify</v-icon>
                                  Filtrele
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="col-lg-12 d-flex flex-wrap">
                <div>
                  <p class="text-center">Gösterilen Kayıt Sayısı</p>
                  <v-btn-toggle mandatory solo dense>
                    <v-btn @click="perPage = 10"> 10</v-btn>
                    <v-btn @click="perPage = 20"> 20</v-btn>
                    <v-btn @click="perPage = 30"> 30</v-btn>
                    <v-btn @click="perPage = 50"> 50</v-btn>
                  </v-btn-toggle>
                </div>
                <div class="ms-auto">
                  <v-btn
                    small
                    color="success darken-1"
                    @click="openNewCollectionDialog"
                    >Tahsilat Oluştur
                  </v-btn>
                </div>
              </div>
              <div class="m-3">
                <b-table
                  head-row-variant="info"
                  table-variant="white"
                  :items="physicalCollectionList"
                  :fields="physicalCollectionListHeaders"
                  hover
                  responsive
                  :per-page="perPage"
                  :busy="physicalCollectionListLoading"
                  style="font-size: 12px"
                  show-empty
                >
                  <template #table-busy>
                    <div class="text-center">
                      <b-spinner
                        variant="primary"
                        size="lg"
                        label="Text Centered"
                      ></b-spinner>
                    </div>
                  </template>
                  <template #empty="scope">
                    <h6 class="text-center my-5">
                      {{
                        scope.loading
                          ? "Lütfen Bekleyin"
                          : noDataMessage
                          ? noDataMessage
                          : "Veri Bulunamadı"
                      }}
                    </h6>
                  </template>
                  <template #cell(amount)="data">
                    <span>{{ numberConverter(data.item.amount) }}</span>
                  </template>
                  <template #cell(date)="data">
                    {{ formattedDate(data.item.date, "DD-MM-YYYY") }}
                  </template>
                  <template #cell(type)="data">
                    {{ data.item.actionType === 1 ? "Nakit" : "Kredi Kartı" }}
                  </template>
                  <template #cell(isErp)="data">
                    <v-chip
                      small
                      label
                      :color="
                        data.item.isErp
                          ? 'success ligthen-2'
                          : 'secondary ligthen-2'
                      "
                    >
                      {{ data.item.isErp ? "Onaylandı" : "Onaylanmadı" }}
                    </v-chip>
                  </template>
                  <template #cell(process)="data">
                    <div>
                      <v-menu :v-model="showActionsMenu" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-1"
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="showActionsMenu = data.item.code"
                          >
                            İşlemler
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-show="data.item.isErp"
                            @click="
                              receiptIdValue = data.item.id;
                              showReceiptDialog = true;
                            "
                          >
                            <v-list-item-icon>
                              <v-icon color="indigo darken-2">mdi-paper</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Makbuz</v-list-item-title>
                          </v-list-item>

                          <v-list-item
                            v-if="
                              user.RoleGroupId === 1 || user.RoleGroupId === '1'
                            "
                            v-show="!data.item.isErp"
                            @click="_collectionApprove(data.item.id)"
                          >
                            <v-list-item-icon>
                              <v-icon color="indigo darken-2">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Onayla</v-list-item-title>
                          </v-list-item>

                          <v-list-item
                            v-if="
                              user.RoleGroupId === 1 || user.RoleGroupId === '1'
                            "
                            @click="
                              processType = 'edit';
                              collectionIdValue = data.item.id;
                              showNewPhyCollectionDialog = true;
                            "
                          >
                            <v-list-item-icon>
                              <v-icon color="indigo darken-2"
                                >mdi-pencil</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title>Düzenle</v-list-item-title>
                          </v-list-item>

                          <v-list-item
                            v-if="
                              user.RoleGroupId === 1 || user.RoleGroupId === '1'
                            "
                            @click="_collectionDelete(data.item.id)"
                          >
                            <v-list-item-icon>
                              <v-icon color="secondary darken-2"
                                >mdi-delete</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title>Sil</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <CollectionReceiptDialog
              :showDialog="showReceiptDialog"
              :collection-id="receiptIdValue"
              @dialogChange="(e) => (showReceiptDialog = e)"
            ></CollectionReceiptDialog>
            <NewPhyCollectionDialog
              :showDialog="showNewPhyCollectionDialog"
              :processType="processType"
              :collection-id="collectionIdValue"
              @dialogChange="(e) => (showNewPhyCollectionDialog = e)"
            ></NewPhyCollectionDialog>
          </div>
        </div>
      </div>
    </v-app>
  </Layout>
</template>

<script>
import NewPhyCollectionDialog from "@/components/collection/NewPhyCollectionDialog.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import { formattedDate } from "@/momentHelper";
import { numberConverter } from "../../../helpers";
import CollectionReceiptDialog from "@/components/collection/CollectionReceiptDialog.vue";
import SearchSelect from "@/components/searchSelect.vue";
import Layout from "@/pages/layout/main";
import PageHeader from "@/components/page-header";

export default {
  name: "PhysicalCollection",
  page: {
    title: "Tahsilat",
    meta: [{ name: "tahsilat", content: "Tahsilat" }],
  },
  components: {
    SearchSelect,
    CollectionReceiptDialog,
    NewPhyCollectionDialog,
    Layout,
    PageHeader,
  },
  computed: {
    ...mapState("company", ["branchList"]),
    ...mapState("auth", ["user"]),
    ...mapState("current", ["salesPersonList"]),
    ...mapState("collactions", [
      "noDataMessage",
      "physicalCollectionList",
      "physicalCollectionListHeaders",
      "physicalCollectionListLoading",
    ]),
  },
  mounted() {
    this._fetchAllCollections();
    this.getBranchList();
  },
  data() {
    return {
      title: "TAHSİLAT LİSTESİ",
      perPage: 10,
      currentPage: 1,
      startDate: null,
      endDate: null,
      type: null,
      isErp: null,
      categoryValue: null,
      selectedCurrent: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      branchcode: null,
      showNewPhyCollectionDialog: false,
      showReceiptDialog: false,
      salesPersonCode: null,
      showActionsMenu: false,
      processType: "new",
      collectionIdValue: null,
      receiptIdValue: null,
    };
  },
  methods: {
    numberConverter,
    ...mapActions("current", ["fetchCurrentList"]),
    ...mapActions("company", ["fetchBranchList"]),
    ...mapActions("collactions", ["fetchAllCollections"]),
    ...mapMutations("company", ["setBranchList"]),
    ...mapActions("collactions", ["collectionDelete", "collectionApprove"]),

    formattedDate,
    closeMenu() {
      this.showActionsMenu = false;
    },
    async _collectionApprove(id) {
      await this.collectionApprove({
        params: {},
        body: {},
        urlSegments: [id],
      });
      this._fetchAllCollections();
    },
    async _collectionDelete(id) {
      await this.collectionDelete({
        params: {},
        body: {},
        urlSegments: [id],
      });
      this._fetchAllCollections();
    },
    _fetchAllCollections() {
      this.fetchAllCollections({
        params: {
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          userId: this.user.UserId,
        },
        body: {
          StartDate: this.startDate,
          EndDate: this.endDate,
          Type: this.type,
          IsErp: this.isErp,
          CurrentCode: this.selectedCurrent,
          SalesPersonCode: this.salesPersonCode,
          BranchCode: this.branchcode,
        },
      });
    },
    async getBranchList() {
      await this.fetchBranchList({
        params: {},
        body: {},
      });
      let tempBranchList = this.branchList.slice();
      tempBranchList.unshift({ code: -1, name: "Tüm Şubeler" });
      this.setBranchList(tempBranchList);
    },
    openNewCollectionDialog() {
      this.processType = "new";
      this.collectionIdValue = "";
      this.showNewPhyCollectionDialog = true;
    },
    async searchCurrentList() {
      this.currentSearchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...((this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2
            ? true
            : false) && { salesPersonCode: this.user.SalesPersonCode }),
          ...((this.currentSearchText == "" || this.currentSearchText == null
            ? false
            : true) && { searchText: this.currentSearchText }),
        },
        body: {},
        onlyData: true,
        loading: false,
      });
      this.searchCurrentLoading = false;
    },
  },
  watch: {
    currentSearchText: function (newVal) {
      if (newVal && newVal.length > 2) {
        if (this.searchCurrentTimeout) clearTimeout(this.searchCurrentTimeout);
        this.searchCurrentLoading = true;
        this.currentSearchResult = [];
        this.searchCurrentTimeout = setTimeout(() => {
          this.searchCurrentList();
        }, 3000);
      } else {
        this.searchCurrentLoading = false;
        if (this.searchCurrentTimeout) clearTimeout(this.searchCurrentTimeout);
      }
    },
  },
};
</script>

<style scoped></style>
